import React from 'react';
import { Navigate } from 'react-router-dom';
import { useGetUserRole } from 'domains/user/hooks/useGetUserRole';
import LoadingScreen from 'components/loading/LoadingScreen';

export default function RoleDashboardRedirectPage() {
  const { role, loading } = useGetUserRole();

  if (loading) {
    return <LoadingScreen />;
  }

  if (role === 'admin') {
    return <Navigate to="/admin/dashboard" replace />;
  }

  if (role === 'partner') {
    return <Navigate to="/dashboard/partner" replace />;
  }

  return <Navigate to="/dashboard/client" replace />;
}
